import { render, staticRenderFns } from "./snippet-preview.vue?vue&type=template&id=2debb20a"
import script from "./snippet-preview.vue?vue&type=script&lang=js"
export * from "./snippet-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports